import React, { Component } from 'react';
import * as firebase from 'firebase';
import './Login.css';
import CompatibilityChecker from '../Utils/CompatibilityChecker';
import { FormattedMessage } from 'react-intl';

let provider = new firebase.auth.FacebookAuthProvider();

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            showLogin: false
        };
    }

    /**
     * login with facebook
     */
    static loginWithFacebook() {
        provider.addScope('user_likes');
        // [END addscopes]
        // [START signin]
        firebase.auth().signInWithRedirect(provider);
    }

    /**
     * logout from facebook
     */
    logOut() {
        firebase.auth().signOut().then(function() {
            this.setState({user: null});
        }.bind(this));
    }

    /**
     * fb redirect listener after login
     */
    componentWillMount(){
        firebase.auth().getRedirectResult().then(function(result) {
            this.props.setUserState(result.user);
        }.bind(this));
    }

    /**
     * authstate listener
     */
    componentDidMount() {
        // Listening for auth state changes.
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                this.props.setUserState(user);
            } else {
                this.setState({'showLogin': true});
            }
        }.bind(this));
    }

    render() {
        if (CompatibilityChecker.checkLocalStorage()) {
            if (this.state.showLogin) {
                return (
                    <div className="login">
                        <button className="loginBtn loginBtn--facebook" onClick={Login.loginWithFacebook}>
                            <FormattedMessage id={ 'login.facebook' } defaultMessage={ 'Mit Facebook anmelden' } />
                        </button>
                    </div>
                );
            } else {
                return (<div />);
            }
        } else {
            return (
                <div className="update-app">Um das Tippspiel zu nutzen, aktualisiere deine App bitte über den Play Store.</div>
            );
        }

    }
}

export default Login;





// WEBPACK FOOTER //
// ./src/Security/Login.js